/**
 * Constants for VinSearch component
 */

// Redirect delay after successful form submission (ms)
export const REDIRECT_DELAY = 5000;

// Success/Error messages
export const SUCCESS_MESSAGE = 'Case created successfully!';
export const ERROR_MESSAGE = 'Failed to create case. Please try again.';
export const VALIDATION_ERROR = 'Please fix the form errors before submitting.';

// Redirect paths
export const REDIRECT_PATH = '/customer-care/case-tracker';
export const LOCATE_ASSET_PATH = '/vehicle-hub/locate-asset';

// VIN validation constants
export const VIN_LENGTH = 17;
export const VIN_VALID_CHARACTERS = /^[A-HJ-NPR-Z0-9]+$/i;
export const VIN_CHECK_DIGIT_POSITION = 8; // 0-indexed (9th position)

// VIN transliteration values for check digit calculation
export const VIN_TRANSLITERATION: Record<string, number> = {
  A: 1,
  B: 2,
  C: 3,
  D: 4,
  E: 5,
  F: 6,
  G: 7,
  H: 8,
  J: 1,
  K: 2,
  L: 3,
  M: 4,
  N: 5,
  P: 7,
  R: 9,
  S: 2,
  T: 3,
  U: 4,
  V: 5,
  W: 6,
  X: 7,
  Y: 8,
  Z: 9,
  '0': 0,
  '1': 1,
  '2': 2,
  '3': 3,
  '4': 4,
  '5': 5,
  '6': 6,
  '7': 7,
  '8': 8,
  '9': 9,
};

// VIN position weights for check digit calculation
export const VIN_POSITION_WEIGHTS = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];

// Case categories
export const CASE_PARENT_CATEGORY = {
  VIN_RELATED: 'VIN_RELATED',
  GENERAL_SUPPORT: 'GENERAL_SUPPORT',
} as const;

export const CASE_SUB_CATEGORY = {
  TECH_SUPPORT_NON_SERVICE: 'TECH_SUPPORT_NON_SERVICE',
  ESCALATION: 'ESCALATION',
  BACK_OFFICE_SUPPORT: 'BACK_OFFICE_SUPPORT',
  PRODUCT_KNOWLEDGE: 'PRODUCT_KNOWLEDGE',
  OTHERS: 'OTHERS',
} as const;

// Lucid Motors CDN base URL for vehicle images
export const LUCID_IMAGE_BASE_URL = 'https://lucidmotors.com/media/image/compare/jellybeans';

// Map simple color names to Lucid CDN color names
export const COLOR_TO_URL_MAP: Record<string, string> = {
  white: 'stellar-white',
  black: 'infinite-black',
  silver: 'cosmos-silver',
  red: 'zenith-red',
  blue: 'fathom-blue',
  grey: 'quantum-gray',
  gray: 'quantum-gray',
  gold: 'stellar-white',
  sapphire: 'fathom-blue',
};

// Map model names to URL trim slugs
export const MODEL_TO_TRIM_MAP: Record<string, string> = {
  pure: 'pure',
  touring: 'touring',
  'grand touring': 'grand-touring',
  'dream edition': 'grand-touring',
  sapphire: 'grand-touring',
};
